import React, { useCallback } from 'react';
import { useAtom } from 'jotai';
import useFeatureFlag from '../../../../common/hooks/useFeatureFlag';
import AdditionalOptions from '../../../../common/side-panel/additional-options';
import type { LabellingValidationsT } from '../../../../common/types/types';
import { FEATURE_FLAGS } from '../../../labelling/constants';
import { isFeatureEnabled } from '../../../labelling/utils/isFeatureEnabled';
import { validationsAtom } from '../../atoms/side-panel-atoms';
export const AdditionalOptionsLabelWrapper = () => {
  const imageCantBeLabelledFFResponse = useFeatureFlag(FEATURE_FLAGS.ENABLE_IMAGE_CANT_BE_LABELLED);
  const isImageCantBeLabelledEnabled = isFeatureEnabled(FEATURE_FLAGS.ENABLE_IMAGE_CANT_BE_LABELLED, imageCantBeLabelledFFResponse);
  const [validations, setValidations] = useAtom(validationsAtom);
  const handleUpdateValidation = useCallback((updatedValidations: LabellingValidationsT) => {
    setValidations(updatedValidations);
  }, [setValidations]);
  return <AdditionalOptions showRequiredLabel={false} updateValidation={handleUpdateValidation} validations={validations} additionOptionsVisibilityConfig={{
    invalidMedia: isImageCantBeLabelledEnabled,
    requiredLabel: false,
    noAnnotation: false
  }} />;
};